import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_MONITORING,
  MONITORING_STORE,
  MONITORING_STORE_URL,
} from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: API_MONITORING,
  });

const monitoringUrlList = createDatasetSlice({
  api,
  storeName: MONITORING_STORE,
  actionName: MONITORING_STORE_URL,
  responseMapping: ResponseMapping.Default,
});

export default monitoringUrlList;
